var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "corporation" }, [
    _c(
      "div",
      { staticClass: "scroll" },
      [
        _c("contents-header", {
          attrs: {
            "bg-type": true,
            title: "MCOP-01-01-02-01",
            description: "MCOP-01-01-02-02"
          }
        }),
        _c("article", { staticClass: "contents" }, [
          _c("div", { staticClass: "form" }, [
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "ovsesCustOcntryName",
                  attrs: {
                    id: "ovsesCustOcntryName",
                    value: _vm.RBF0409E40.ovsesCustOcntryName,
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-03"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "coTelno",
                  attrs: {
                    id: "coTelno",
                    value: _vm.RBF0409E40.coTelno,
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-04"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "faxNo",
                  attrs: {
                    id: "faxNo",
                    value: _vm.RBF0409E40.faxNo,
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-05"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "item-tit" }, [
                _vm._v(_vm._s(/*법인소재지주소*/ _vm.$t("MCOP-01-01-02-06")))
              ]),
              _c(
                "div",
                { staticClass: "item-desc" },
                [
                  _vm.RBF0409E40.coprNmad
                    ? _c("input-text", {
                        ref: "coprNmad",
                        attrs: {
                          id: "coprNmad",
                          value: _vm.RBF0409E40.coprNmad,
                          disabled: ""
                        }
                      })
                    : _vm._e(),
                  _c("input-text", {
                    ref: "coprAddr1",
                    attrs: {
                      id: "coprAddr1",
                      value: _vm.RBF0409E40.coprAddr1,
                      disabled: ""
                    }
                  }),
                  _vm.RBF0409E40.coprAddr2
                    ? _c("input-text", {
                        ref: "coprAddr2",
                        attrs: {
                          id: "coprAddr2",
                          value: _vm.RBF0409E40.coprAddr2,
                          disabled: ""
                        }
                      })
                    : _vm._e(),
                  _vm.RBF0409E40.coprAddr3
                    ? _c("input-text", {
                        ref: "coprAddr3",
                        attrs: {
                          id: "coprAddr3",
                          value: _vm.RBF0409E40.coprAddr3,
                          disabled: ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "rprsOcntryName",
                  attrs: {
                    id: "rprsOcntryName",
                    value: _vm.RBF0409E40.rprsOcntryName,
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-07"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "cphnNo",
                  attrs: {
                    id: "cphnNo",
                    value: _vm.RBF0409E40.cphnNo,
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-08"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "exno",
                  attrs: {
                    id: "exno",
                    value: _vm.RBF0409E40.exno,
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-09"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "rprsEmad1",
                  attrs: {
                    id: "rprsEmad1",
                    value: _vm.RBF0409E40.rprsEmad1,
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-10"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "item-tit" }, [
                _vm._v(_vm._s(/*대표자 주소*/ _vm.$t("MCOP-01-01-02-11")))
              ]),
              _c(
                "div",
                { staticClass: "item-desc" },
                [
                  _vm.RBF0409E40.rprsNmad
                    ? _c("input-text", {
                        ref: "rprsNmad",
                        attrs: {
                          id: "rprsNmad",
                          value: _vm.RBF0409E40.rprsNmad,
                          disabled: ""
                        }
                      })
                    : _vm._e(),
                  _c("input-text", {
                    ref: "rprsAddr1",
                    attrs: {
                      id: "rprsAddr1",
                      value: _vm.RBF0409E40.rprsAddr1,
                      disabled: ""
                    }
                  }),
                  _vm.RBF0409E40.rprsAddr2
                    ? _c("input-text", {
                        ref: "rprsAddr2",
                        attrs: {
                          id: "rprsAddr2",
                          value: _vm.RBF0409E40.rprsAddr2,
                          disabled: ""
                        }
                      })
                    : _vm._e(),
                  _vm.RBF0409E40.rprsAddr3
                    ? _c("input-text", {
                        ref: "rprsAddr3",
                        attrs: {
                          id: "rprsAddr3",
                          value: _vm.RBF0409E40.rprsAddr3,
                          disabled: ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c("input-text", {
                  ref: "postSendAreaDstcd",
                  attrs: {
                    id: "postSendAreaDstcd",
                    value: _vm.$te(
                      _vm.RBF0409E40.postSendAreaDstcd + "_우편발송지구분코드"
                    )
                      ? _vm.$t(
                          _vm.RBF0409E40.postSendAreaDstcd +
                            "_우편발송지구분코드"
                        )
                      : "",
                    disabled: "",
                    "label-i18n": "MCOP-01-01-02-12"
                  }
                })
              ],
              1
            ),
            _vm.siteCode === _vm.$config.SITECODE_OGAUC
              ? _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c("input-text", {
                      ref: "postSendYn",
                      attrs: {
                        id: "postSendYn",
                        value: _vm.$te(
                          _vm.RBF0409E40.postSendYn + "_우편발송여부"
                        )
                          ? _vm.$t(_vm.RBF0409E40.postSendYn + "_우편발송여부")
                          : "",
                        disabled: "",
                        "label-i18n": "MCOP-01-01-02-14"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm.siteCode === _vm.$config.SITECODE_OGAUC
            ? _c("div", { staticClass: "info info-etc" }, [
                _vm._v(
                  "※ " +
                    _vm._s(
                      /*조회 > 거래내역조회 > Statement조회 에서 조회 후 인쇄할 수 있습니다.*/ _vm.$t(
                        "MCOP-01-01-02-16"
                      )
                    )
                )
              ])
            : _vm._e()
        ])
      ],
      1
    ),
    _c("div", { staticClass: "btn-area--full fixed" }, [
      _c(
        "button",
        { staticClass: "btn md gray", on: { click: _vm.goPrevStep } },
        [_vm._v(_vm._s(/*뒤로*/ _vm.$t("MCOM-0000078")))]
      ),
      _vm.isCorporationMasterUser
        ? _c(
            "button",
            { staticClass: "btn md normal", on: { click: _vm.goNextStep } },
            [_vm._v(_vm._s(/*수정*/ _vm.$t("MCOP-01-01-02-18")))]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }